import { useEffect, useState } from "react";
import { Cake, Loader2, CalendarDays } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";

const MONTHS = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];

export const BirthdayCalendarDialog = ({ open, onClose }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (open) { setItems(null); api.get("/celebrations/calendar").then((r) => setItems(r.data)).catch(() => setItems([])); }
  }, [open]);

  const byMonth = (items || []).reduce((acc, b) => { (acc[b.month] = acc[b.month] || []).push(b); return acc; }, {});

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="brutal border-2 border-brand-ink bg-white rounded-xl max-h-[90vh] overflow-auto no-scrollbar" data-testid="birthday-calendar-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-head font-black text-xl flex items-center gap-2">
            <CalendarDays className="w-5 h-5" strokeWidth={2.5} />Verjaardagskalender
          </DialogTitle>
        </DialogHeader>
        {items === null ? (
          <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : items.length === 0 ? (
          <p className="text-sm text-brand-ink/50 py-6 text-center">Nog geen verjaardagen ingevuld. Vul je geboortedatum in bij je profiel! 🎂</p>
        ) : (
          <div className="space-y-4" data-testid="birthday-calendar-list">
            {MONTHS.map((m, idx) => {
              const month = idx + 1;
              const list = byMonth[month];
              if (!list) return null;
              return (
                <div key={month}>
                  <p className="font-head font-black text-sm uppercase tracking-wide text-brand-violet mb-1.5">{m}</p>
                  <div className="space-y-1.5">
                    {list.map((b) => (
                      <div key={b.user_id} data-testid={`bday-cal-${b.user_id}`} className={`brutal-sm rounded-xl px-3 py-2 flex items-center gap-3 text-sm ${b.is_today ? "bg-brand-yellow" : "bg-white"}`}>
                        <div className="w-9 h-9 rounded-lg border-2 border-brand-ink bg-brand-pink/30 flex flex-col items-center justify-center shrink-0 leading-none">
                          <span className="font-black text-sm">{b.day}</span>
                        </div>
                        <Cake className="w-4 h-4 shrink-0" strokeWidth={2.5} />
                        <span className="flex-1 min-w-0 truncate font-bold">{b.name}</span>
                        {b.is_today ? <span className="text-xs font-black">Vandaag! 🎉</span> : <span className="text-xs font-semibold text-brand-ink/50">wordt {b.turning}</span>}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BirthdayCalendarDialog;
